import { MagnifyingGlassCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedTreatmentRequestResearchCompletedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface TreatmentRequestResearchCompletedEventProps {
  event: DiscriminatedTreatmentRequestResearchCompletedEvent;
}

export const TreatmentRequestResearchCompletedEvent: React.FC<
  TreatmentRequestResearchCompletedEventProps
> = ({ event }) => {
  const methodCount = event.payload.submission_methods?.length || 0;
  const selectedCount = event.payload.selected_submission_methods?.length || 0;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-cyan-100">
          <MagnifyingGlassCircleIcon className="h-4 w-4 text-cyan-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        <div className="text-sm text-gray-600">
          Found {methodCount} submission method{methodCount !== 1 ? 's' : ''}
        </div>
        {selectedCount > 0 && (
          <div className="text-xs text-gray-500">
            {selectedCount} method{selectedCount !== 1 ? 's' : ''} selected
          </div>
        )}
      </ActivityDescription>
    </ActivityBody>
  );

  const actions = event.payload.provider_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/treatment/${event.payload.provider_id}`}
      >
        View Provider
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Request Research Completed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
